import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar'
import Footer2 from '../../Footer2/Footer2'
import BusinessRelease from '../../BlogDetail/BusinessRelease/BusinessRelease'
import GlobalVision from '../../BlogDetail/GlobalVision/GlobalVision'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const BlogDetailPage = () => {
  return (
    <div>
      <TopBar/>
      <Navbar/>
      <BusinessRelease/>
      <GlobalVision/>
      <Footer2/>
    </div>
  )
}

export default BlogDetailPage
